import Pagination from "@mui/material/Pagination"
import Stack from "@mui/system/Stack"
import Typography from "@mui/material/Typography"
import MenuItem from "@mui/material/MenuItem"
import Grid from "@mui/material/Grid"
import useWindowSize from "@components/_hooks/useWindowSize"
import dynamic from "next/dynamic"

const SelectInput = dynamic(() => import('@components/Custom/Inputs/SelectInput'));


const ArticlePagination = (props) => {
    const {
        count, 
        page, 
        from,
        to,
        total,
        per_page,
        handleChange,
        handlePaginationChange,
        setPerPage
    } = props

    const {isMobile} = useWindowSize();

    const getMenuItems = () => {
        const arr = [Number(per_page), 10, 20, 30];
        const new_arr = [...new Set(arr)];
        return new_arr
    }


    return (
        <Stack className="mb-4" spacing={2} direction="row">
                <Grid rowSpacing={{xs: 2, md: 0}} container>
                    <Grid className="d-flex" item>
                        <Typography className="text-vertical" component="span">Results {from} - {to} of {total}</Typography>&nbsp;&nbsp;&nbsp;
                        <Typography className="text-vertical" component="span">Show</Typography> &nbsp;&nbsp;
                        <SelectInput
                            useCustomMenuProps={false}
                            formControlClasses="w-auto"
                            size="small"
                            name="per_page"
                            onChange={handleChange}
                            value={per_page}
                            
                        >
                            {
                                getMenuItems().map((key) => (
                                    <MenuItem key={key} value={key}>{key}</MenuItem>
                                ))
                            }
                        </SelectInput>
                        <Typography className="text-vertical" component="span">&nbsp;&nbsp;per page</Typography>&nbsp;&nbsp;

                    </Grid>
                    <Grid item>
                        <Pagination onChange={handlePaginationChange} page={page} count={count} siblingCount={isMobile ? 1 : 4} color="primary" variant="outlined" shape="rounded" />
                    </Grid>
                </Grid>
        </Stack>
    )
}

export default ArticlePagination;